<template>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col p-col-12 p-md-12 p-lg-3" style="font-size: 16px">
      <Panel header="Tra cứu thông tin CLS của bệnh nhân">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
            <label style="font-size: 16px">Mã y tế</label>
            <InputText id="name" type="text" v-model="maYTe" style="text-align: center;font-size: 16px"/>
          </div>
          <div class="p-field p-col p-col-12 p-md-6 p-lg-6">
            <label style="font-size: 16px">Tra cứu</label>
            <Button label="Tìm" icon="pi pi-plus-circle" iconPos="left" @click="loadListCls()" style="font-size: 16px"/>
          </div>
        </div>
      </Panel>
    </div>
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 16px">
      <Panel header="Thông tin bệnh nhân" v-if="listCLS.length > 0">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Mã y tế</label>
            <InputText id="maYTe" type="text" v-model="listCLS[0].mayte" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Họ và tên</label>
            <InputText id="hoVaTen" type="text" v-model="listCLS[0].tenbenhnhan" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Ngày sinh</label>
            <InputText id="ngaySinh" v-model="ngaySinh" type="text" style="text-align: center;font-size: 16px" disabled>
            </InputText>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Giới tính</label>
            <InputText id="gioiTinh" type="text" v-model="listCLS[0].gioitinh" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-4 p-lg-3">
            <label style="font-size: 16px">CCCD/CMND</label>
            <InputText id="cmnd" type="text" v-model="listCLS[0].cmnd" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-4 p-lg-3">
            <label style="font-size: 16px">Số điện thoại</label>
            <InputText id="dt" type="text" v-model="listCLS[0].sodienthoai" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <label style="font-size: 16px">Địa chỉ thường trú</label>
            <InputText id="diaChi" type="text" v-model="listCLS[0].diachithuongtru" style="text-align: center;font-size: 16px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <Button class="p-button-outlined" label="Thêm kết quả CLS" onclick="document.getElementById('myFile').click()" icon="pi pi-paperclip" />
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3" v-if="listFileName.length > 0">
            <Button label="Gởi kết quả cho bệnh nhân" @click="upload()" icon="pi pi-send" style="margin-right: 5vw" severity="warning"/>
          </div>
          <div class="p-field p-col-4 p-sm-4 p-md-3">
            <form enctype="multipart/form-data">
              <input id="myFile" type="file" style="display: none;" accept=".pdf" name="files" v-on:change="fileChange($event.target.files)" :disabled="loadingBar" />
            </form>
          </div>
        </div>
      </Panel>
        </div>
        <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
      <Panel header="Dữ liệu kết quả CLS" v-if="!permissionCLS">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
            <DataTable
                :loading="isLoading"
                :value="listFileCls" :paginator="true" stripedRows :rows="30"
                :rowsPerPageOptions="[30,50,100]" :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['tendichvu']"
                currentPageReportTemplate="Có tổng số {totalRecords} dữ liệu kết quả   CLS" columnResizeMode="fit | expand">
              <template #header>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
                  <span class="p-input-icon-left" style="width: 18em">
<!--                    <i class="pi pi-search" />-->
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo dịch vụ" />
                  </span>
                </div>
              </template>
<!--              <Column field="mayte" header="Mã y tế" sortable></Column>-->
<!--              <Column field="tenbenhnhan" header="Tên bệnh nhân" sortable></Column>-->
<!--              <Column field="ngaysinh" header="Ngày sinh">-->
<!--                <template #body="slotProps">-->
<!--                  {{formatDateTime(slotProps.data.ngaysinh)}}-->
<!--                </template>-->
<!--              </Column>-->
<!--              <Column field="sodienthoai" header="Số điện thoại" sortable></Column>-->
<!--              <Column field="diachithuongtru" header="Địa chỉ" sortable></Column>-->
<!--              <Column field="cmnd" header="CCCD/CMND" sortable></Column>-->
<!--              <Column field="gioitinh" header="Giới tính" sortable></Column>-->
              <Column field="fullName" header="Tên tài khoản gởi" sortable></Column>
              <Column field="time" header="Thời gian gởi" sortable>
                <template #body="slotProps">
                  {{formatDateTime(slotProps.data.time)}}
                </template>
              </Column>
              <Column field="path" header="Tên tập tin" sortable>
              </Column>
              <Column field="trangThai" header="Tình trạng" sortable>
                <template #body="slotProps">
                  <label v-if="slotProps.data.trangThai">Đã gởi dữ liệu cho khách hàng</label>
                  <label v-else>Chưa gởi dữ liệu cho khách hàng </label>
                </template>
              </Column>
              <Column header="Tùy chọn">
                <template #body="slotProps">
                  <Button v-if="!slotProps.data.trangThai" severity="secondary" label="Gởi cho khách hàng" icon="pi pi-sent" @click="sendFileResult(slotProps.data.id)">
                  </Button>
                  <Button v-else severity="danger" label="Gởi lại cho khách hàng" icon="pi pi-sent" @click="sendFileResult(slotProps.data.id)">
                  </Button>
                </template>
              </Column>
<!--              <Column header="Chỉnh sửa">-->
<!--                <template #body="slotProps">-->
<!--                    <Button class="p-button-danger" label="Xoá" icon="pi pi-trash" @click="deleteCar(slotProps.data.id)">-->
<!--                    </Button>-->
<!--                </template>-->
<!--              </Column>-->
            </DataTable>
          </div>
        </div>
      </Panel>
    </div>
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
      <Panel header="Danh sách dịch vụ CLS">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
            <DataTable
                :loading="isLoading"
                :value="listCLS" :paginator="true" stripedRows :rows="30"
                :rowsPerPageOptions="[30,50,100]" :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['tendichvu']"
                currentPageReportTemplate="Có tổng số {totalRecords} dịch vụ CLS" columnResizeMode="fit | expand">
              <template #header>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
                  <span class="p-input-icon-left" style="width: 18em">
<!--                    <i class="pi pi-search" />-->
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo dịch vụ" />
                  </span>
                </div>
              </template>
<!--              <Column field="mayte" header="Mã y tế" sortable></Column>-->
<!--              <Column field="tenbenhnhan" header="Tên bệnh nhân" sortable></Column>-->
<!--              <Column field="ngaysinh" header="Ngày sinh">-->
<!--                <template #body="slotProps">-->
<!--                  {{formatDateTime(slotProps.data.ngaysinh)}}-->
<!--                </template>-->
<!--              </Column>-->
<!--              <Column field="sodienthoai" header="Số điện thoại" sortable></Column>-->
<!--              <Column field="diachithuongtru" header="Địa chỉ" sortable></Column>-->
<!--              <Column field="cmnd" header="CCCD/CMND" sortable></Column>-->
<!--              <Column field="gioitinh" header="Giới tính" sortable></Column>-->
              <Column field="tendichvu" header="Tên dịch vụ" sortable></Column>
              <Column field="ngaygioyeucau" header="Thời gian yêu cầu" sortable>
                <template #body="slotProps">
                  {{formatDateTime(slotProps.data.ngaygioyeucau)}}
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script lang="ts">

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {ListCustomer} from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {ManagerCheckinCreate} from "@/models/managerCheckinCreate";
import {ManagerCheckin} from "@/models/managerCheckin";
import {CarObject} from "@/models/carObject";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const listFileCls = ref([] as Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const loadListCls = () => {
      console.log("#####$$$$$$$$$$ loadListCls: " );
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ listCLS.value.length: " + listCLS.value.length);
            if(listCLS.value[0].ngaysinh != null)
            {
              ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");

            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  console.log("#####$$$$$$$$$$ getListCLS: " + JSON.stringify(response.data));
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                   x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ loadListCls 1111111: " );
            console.log("#####$$$$$$$$$$ loadListCls 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ loadListCls 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };
    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);
    function base64ToBlob(base64: string, mime = 'image/jpeg'): Blob {
      const byteString = atob(base64.split(',')[1]);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([byteArray], { type: mime });
    }
    const loadingBar = ref(false);
    const upload = () => {
      {
        // listCLS.value[0].sodienthoai = "0905333122"; // debug
        // listCLS.value[0].sodienthoai = "0905123456"; // debug
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach(x =>
        {
          const blob = base64ToBlob(x.value); // convert từ string sang Blob
          files.append("formFiles", blob, x.nameFile);
        });
        loadingBar.value = true;
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        axios.post(`../api/File/UploadFileCLS/${listCLS.value[0].sodienthoai}/${maYTe.value}`, files,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {

          loadingBar.value = false;
          listFileName.value = [];
          if(response.data.status) {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Tải kết quả thành công',
              life: 2000
            });
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          }
          else{
            toast.add({
              severity: 'warn',
              summary: 'Lỗi',
              detail:response.data.log,
              life: 2500
            });
          }
        })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
    };

    const fileChange = (fileList) => {
      var leng = fileList.length;
      for (var i = 0; i < leng; i++)
      {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const sendFileResult = (id: number) => {
      console.log("#####$$$$$$$$$$ sendResult: " );
      zaloRepository.sendResult(id)
          .then((response) => {
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
            console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    return {
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      loadListCls,
      ngaySinh,
      upload,
      listLink,
      listFileName,
      loadingBar,
      fileChange,
      listFileCls,
      sendFileResult,
      permissionCLS
    }
  }
}

</script>
